import React, { createContext, useState, useContext } from "react";
import TableCell from "@mui/material/TableCell";
import Skeleton from "react-loading-skeleton";
/*Context Here*/

const TableContext = createContext({ loading: false, setLoading: () => {} });

export const TableContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <TableContext.Provider value={{ loading, setLoading }}>
      {children}
    </TableContext.Provider>
  );
};

export const useTableContext = () => useContext(TableContext);

/*Context End!*/

/*HOC Component that return either skeleton or componet bassed on loading state*/ export const DynamicTableCell =
  ({ children }) => {
    const { loading } = useTableContext();

    return (
      <>
        {loading ? (
          <TableCell align="left">
            <Skeleton className="user-load h-20 w-full" />
          </TableCell>
        ) : (
          <>{children}</>
        )}
      </>
    );
  };
